<template>
  <v-app id="materialpro" :class="`${!$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'}`">
    <router-view/>
  </v-app>

</template>

<script>

import axios from "axios";
import Constants from "@/const/Const";

export default {

  name: 'App',

  components: {},
  created() {
    axios.defaults.baseURL = Constants.BASE_URL
  }

};
</script>
